const environment = process.env.REACT_APP_ENV as 'local' | 'stage' | 'prod';

const environments = {
  local: {
    serverURL: 'http://localhost:5004',
    serverURLV2: 'http://localhost:5004',
    albServerUrl: 'http://localhost:5004',
    backtestingURL: 'http://localhost:8081',
    liveTickServerUrl: 'http://localhost:8082',
    websocketServerUrl: 'ws://localhost:5004/ws'
  },
  stage: {
    serverURL: 'https://pr3cpr9xdd.execute-api.ap-south-1.amazonaws.com',
    serverURLV2: 'http://13.235.33.186:8080',
    albServerUrl: 'https://stagesocket.vealth1st.com',
    backtestingURL: 'http://localhost:8081',
    liveTickServerUrl: 'https://dx09vmdfp7.execute-api.ap-south-1.amazonaws.com/prod',
    websocketServerUrl: 'wss://stagesocket.vealth1st.com/ws'
  },
  prod: {
    serverURL: 'https://exz91xbdgj.execute-api.ap-south-1.amazonaws.com',
    albServerUrl: 'https://socket.vealth1st.com',
    serverURLV2: 'http://3.109.159.194:8080',
    backtestingURL: 'http://localhost:8081',
    liveTickServerUrl: 'https://dx09vmdfp7.execute-api.ap-south-1.amazonaws.com/prod',
    websocketServerUrl: 'wss://socket.vealth1st.com/ws'
  }
};

export const ENV_CONFIG = environments[environment] || environments.local;
